package com.tixforgigs.common.ui.pages.login


import com.tixforgigs.common.CommonBuildKonfig
import com.tixforgigs.common.core.enums.LoginMode
import com.tixforgigs.common.core.enums.MandarinInputType
import com.tixforgigs.common.core.enums.View
import com.tixforgigs.common.core.extensions.RoutingUtil.AppScope
import com.tixforgigs.common.core.extensions.RoutingUtil.routing
import com.tixforgigs.common.core.extensions.navigateTo
import com.tixforgigs.common.core.extensions.orElse
import com.tixforgigs.common.core.interfaces.StorefrontPage
import com.tixforgigs.common.core.models.ui.InputState
import com.tixforgigs.common.core.util.AuthUtil.login
import com.tixforgigs.common.core.util.AuthUtil.signup
import com.tixforgigs.common.core.util.DateTimeUtil.currentInstant
import com.tixforgigs.common.core.util.InputUtil.emailRegex
import com.tixforgigs.common.core.util.TrackerUtil.pageView
import com.tixforgigs.common.ui.components.grid.gridContainer
import com.tixforgigs.common.ui.components.mandarin.mandarinFilledButton
import com.tixforgigs.common.ui.components.mandarin.mandarinInput
import com.tixforgigs.common.ui.components.mandarin.mandarinTitle
import com.tixforgigs.common.ui.components.root.defaultTemplate
import com.tixforgigs.tarami.GlobalMessage.buttonLogin
import com.tixforgigs.tarami.GlobalMessage.buttonSignUp
import com.tixforgigs.tarami.GlobalMessage.textPasswordForgot
import com.tixforgigs.tarami.GlobalMessage.titleLogin
import io.kvision.core.*
import io.kvision.event.clickFlow
import io.kvision.html.span
import io.kvision.material.ExperimentalMaterialApi
import io.kvision.material.tabs.primaryTab
import io.kvision.material.tabs.tabs
import io.kvision.panel.SimplePanel
import io.kvision.panel.hPanel
import io.kvision.panel.simplePanel
import io.kvision.utils.px
import kotlinx.coroutines.MainScope
import kotlinx.coroutines.flow.*
import kotlinx.coroutines.launch
import kotlinx.datetime.LocalDate
import kotlinx.datetime.TimeZone
import kotlinx.datetime.atStartOfDayIn
import kotlin.time.ExperimentalTime


@OptIn(ExperimentalMaterialApi::class, ExperimentalTime::class)
class LoginView : SimplePanel(className = "xm-page xm-page-auth-login"), StorefrontPage {

  override val VIEW: View get() = View.LOGIN

  val mSelectedMode = MutableStateFlow(LoginMode.LOGIN)

  val mEmailInput =
    MutableStateFlow<InputState<String?>>(
      InputState(
        CommonBuildKonfig.TEST_USER,
        CommonBuildKonfig.TEST_USER.matches(emailRegex)
      )
    )
  val mPasswordInput =
    MutableStateFlow<InputState<String?>>(
      InputState(
        CommonBuildKonfig.TEST_PASS,
        CommonBuildKonfig.TEST_PASS.isNotEmpty()
      )
    )

  val mDateOfBirthInput = MutableStateFlow(
    InputState(
      if (CommonBuildKonfig.TEST_DOB.isNotEmpty()) LocalDate.parse(CommonBuildKonfig.TEST_DOB) else null,
      CommonBuildKonfig.TEST
    )
  )
  val mGivenNameInput = MutableStateFlow<InputState<String?>>(InputState(CommonBuildKonfig.TEST_GN, true))
  val mFamilyNameInput = MutableStateFlow<InputState<String?>>(InputState(CommonBuildKonfig.TEST_SN, true))

  val inputsValid = combine(mSelectedMode, mEmailInput, mPasswordInput) { mode, email, password ->
    when (mode) {
      LoginMode.LOGIN -> email.isValid && password.isValid
      LoginMode.SIGNUP -> email.isValid && password.isValid
    }
  }.stateIn(MainScope(), SharingStarted.Eagerly, false)


  init {
    AppScope.launch {
      pageView()
    }

    defaultTemplate {
      simplePanel(className = "xm-body") {

        gridContainer().bind(mSelectedMode) { selectedMode ->
          gridItem(12) {
            mandarinTitle(titleLogin())
          }
          gridItem(12) {
            tabs(activeTabIndex = selectedMode.index) {
              marginBottom = 32.px
              LoginMode.entries.forEach { mode ->
                primaryTab(
                  text = mode.title,
                  active = selectedMode == mode
                ).onClick {
                  mSelectedMode.update { mode }
                }
              }
            }
          }
          gridItem(6, 4) {
            mandarinInput(
              state = mEmailInput,
              inputType = MandarinInputType.EMAIL
            )
          }
          gridItem(6, 4) {
            mandarinInput(
              state = mPasswordInput,
              inputType = MandarinInputType.PASSWORD
            )
          }
          if (selectedMode == LoginMode.SIGNUP) {
            gridItem(6, 4) {
              mandarinInput(
                state = mGivenNameInput,
                inputType = MandarinInputType.FIRST_NAME
              )
            }
            gridItem(6, 4) {
              mandarinInput(
                state = mFamilyNameInput,
                inputType = MandarinInputType.LAST_NAME
              )
            }
            gridItem(6, 4) {
              mandarinInput(
                state = mDateOfBirthInput,
                inputType = MandarinInputType.BIRTHDATE
              )
            }
          }
          if (selectedMode == LoginMode.LOGIN) {
            gridItem(6, 4) {
              hPanel(
                justify = JustifyContent.START,
              ) {
                span {
                  textDecoration = TextDecoration(line = TextDecorationLine.UNDERLINE)
                  cursor = Cursor.POINTER

                  +textPasswordForgot()
                }.clickFlow.onEach {
                  routing.navigateTo(View.FORGOT_PASSWORD)
                }.launchIn(MainScope())
              }
            }
          }
          gridItem(12) {
            simplePanel(className = "xm-buttons xm-justify-end xm-auto") {

              mandarinFilledButton(
                title = when (selectedMode) {
                  LoginMode.LOGIN -> buttonLogin()
                  LoginMode.SIGNUP -> buttonSignUp()
                },
                isEnabled = inputsValid
              ) {
                when (mSelectedMode.value) {
                  LoginMode.LOGIN -> {
                    login(
                      mEmailInput.value.inputValue.orEmpty(),
                      mPasswordInput.value.inputValue.orEmpty()
                    )
                  }

                  LoginMode.SIGNUP -> {
                    signup(
                      mEmailInput.value.inputValue.orEmpty(),
                      mPasswordInput.value.inputValue.orEmpty(),
                      mFamilyNameInput.value.inputValue.orEmpty(),
                      mGivenNameInput.value.inputValue.orEmpty(),
                      mDateOfBirthInput.value.inputValue?.atStartOfDayIn(TimeZone.currentSystemDefault())
                        .orElse { currentInstant }
                      /** TODO use LocalDate see: TASK-123 **/
                    )
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
